<template>
    <div>

        <div class="custom_inputs-container">
            <input type="phone" maxlength="1" :class="{underscore : value_1 === ''}" id="1" @keyup="keyUpAction($event)"
                   ref="1">
            <input type="phone" maxlength="1" :class="{underscore : !value_2}" id="2" @keyup="keyUpAction($event)"
                   ref="2">
            <input type="phone" maxlength="1" :class="{underscore : !value_3}" id="3" @keyup="keyUpAction($event)"
                   ref="3">
            <input type="phone" maxlength="1" :class="{underscore : !value_4}" id="4" @keyup="keyUpAction($event)"
                   ref="4">
            <input type="phone" maxlength="1" :class="{underscore : !value_5}" id="5" @keyup="keyUpAction($event)"
                   ref="5">
            <input type="phone" maxlength="1" :class="{underscore : !value_6}" id="6" @keyup="keyUpAction($event)"
                   ref="6">
            <input type="phone" maxlength="1" :class="{underscore : !value_7}" id="7" @keyup="keyUpAction($event)"
                   ref="7">
            <input type="phone" maxlength="1" :class="{underscore : !value_8}" id="8" @keyup="keyUpAction($event)"
                   ref="8">
            <input type="phone" maxlength="1" :class="{underscore : !value_9}" id="9" @keyup="keyUpAction($event)"
                   ref="9">
        </div>

        <div class="smth">
            <span v-html="value_1"/>
            <span v-html="value_2"/>
            <span v-html="value_3"/>
            <span v-html="value_4"/>
            <span v-html="value_5"/>
            <span v-html="value_6"/>
            <span v-html="value_7"/>
            <span v-html="value_8"/>
            <span v-html="value_9"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SeparatedFields",
        data() {
            return {
                value_1: '',
                value_2: '',
                value_3: '',
                value_4: '',
                value_5: '',
                value_6: '',
                value_7: '',
                value_8: '',
                value_9: '',
                regexp: new RegExp('^[a-zA-Z0-9_]+$')
            }
        },
        methods: {

            keyUpAction(event) {
                let targetId = event.currentTarget.id;

                if (this.regexp.test(event.currentTarget.value)) {

                    this.$refs[parseInt(targetId, 10) + 1].focus();

                } else {

                    this[`value_${targetId}`] = '';
                }


                if (event.key === 'Backspace') {

                    this.$refs[parseInt(targetId, 10) - 1].focus();

                } else if (event.key === 'ArrowRight') {

                    this.$refs[parseInt(targetId, 10) + 1].focus();


                } else if (event.key === 'ArrowLeft') {

                    this.$refs[parseInt(targetId, 10) - 1].focus();
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .custom_inputs-container {

        input {
            font-size: 16px;
            font-weight: 500;
            margin: 0 3px;
            text-transform: uppercase;
            width: 10px;
            padding: 0;
            text-align: center;
            border-left: unset;
            border-top: unset;
            border-right: unset;
            border-bottom: unset;
            transition: border-bottom 0.3s;

            &.underscore {
                border-bottom: 2px solid #2a435e;
            }
        }
    }

    .smth {
        margin-top: 10px;
        border: 1px solid red;
        height: 20px;

        span {
            display: inline-block;
            margin: 0 3px;
            color: black;
            font-size: 15px;
            border-bottom: 2px solid #2a435e;
            width: 10px;


        }
    }
</style>